import { BackButtonRounded } from '../../buttons/BackButtonRounded.tsx';
import AccountSettingsPageTitle from './AccountSettingsPageTitle.tsx';
import { useNavigate } from 'react-router-dom';
//
// interface IBackButton {
//     label: string;
//     link: string;
// }

interface IProps {
    title: string;
    backButtonIsVisible?: boolean;
}

const AccountSettingsHeader = ({ title, backButtonIsVisible = false }: IProps) => {
    const navigate = useNavigate();
    const handleBackButtonClick = () => {
        navigate(-1);
    };
    return (
        <div className={'flex gap-3 items-center mb-5'}>
            {backButtonIsVisible && <BackButtonRounded onClick={handleBackButtonClick} />}
            <AccountSettingsPageTitle title={title} />
        </div>
    );
};

export default AccountSettingsHeader;